import { render, staticRenderFns } from "./orderpay.vue?vue&type=template&id=7cc616bd&scoped=true"
import script from "./orderpay.vue?vue&type=script&lang=js"
export * from "./orderpay.vue?vue&type=script&lang=js"
import style0 from "./orderpay.vue?vue&type=style&index=0&id=7cc616bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc616bd",
  null
  
)

export default component.exports